import { loadVoiceId, saveVoiceId } from '@/ai/aiServices/chatStorage'

export async function speakWithElevenLabs(text) {
  const API_KEY = process.env.VUE_APP_ELEVENLABS_API
  const MODEL_ID = 'eleven_multilingual_v2'
  const VOICE_ID = 'uvysWDLbKpA4XvpD3GI6' // Leonie

  if (!text || typeof text !== 'string') return

  try {
    const cleanedText = text
      .replace(/\bPIA\b/gi, 'Pia')
      .replace(/([.,!?])(?=\S)/g, '$1 ')
      .replace(/\s+/g, ' ')

    const url = `https://api.elevenlabs.io/v1/text-to-speech/${VOICE_ID}/stream`
    const payload = {
      text: cleanedText,
      model_id: MODEL_ID,
      voice_settings: {
        stability: 0.9,
        similarity_boost: 0.95,
        style: 0.3,
        use_speaker_boost: true,
      },
    }

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'xi-api-key': API_KEY,
        'Content-Type': 'application/json',
        Accept: 'audio/mpeg',
      },
      body: JSON.stringify(payload),
    })

    if (!res.ok) {
      const errText = await res.text()
      throw new Error(`TTS failed: ${res.status} ${errText}`)
    }

    const blob = await res.blob()
    const audioUrl = URL.createObjectURL(blob)
    const audio = new Audio(audioUrl)
    audio.play()
    return audio
  } catch (err) {
    console.error('❌ ElevenLabs TTS error:', err.message || err)
  }
}
